import { getPathMatch } from 'next/dist/shared/lib/router/utils/path-match';

export type MatchPathPatternOptions = Parameters<typeof getPathMatch>[1];

export const matchPathPattern = (pathname: string, pathPattern: string, options?: MatchPathPatternOptions) => {
  const matcher = getPathMatch(pathPattern, options);

  return matcher(pathname);
};
